
export enum CustomerUserOPEEnum {
  ResetPasswordByEmail = 'resetPasswordByEmail',
  PutCustomerUser = 'putCustomerUser',
  GetUserToken = 'getUserToken',
  GetCustomerUsers = 'getCustomerUsers',
  DelCustomerUser = 'delCustomerUser',
  ChangeUserOwner = 'changeUserOwner'
}
